import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { useStore } from '@stores/RootStore';
import { fonts } from '@theme/fontsCustomer';
import { DirectApiConfig } from './DirectApiConfig';
// import { NoTriggerConfig } from './NoTriggerConfig';
import { NoTriggerConfig } from './NoTriggerConfig';
import { SchedulerConfig } from './SchedulerConfig';

export const TriggerConfig = () => {
  const { t } = useTranslation();
  const { workflowDetailStore } = useStore();

  const isEditTable = workflowDetailStore.checkEditable();
  const isConfigurable = !!workflowDetailStore.triggerNode?.data?.baseTriggerModel?.isConfigurable;

  const renderTriggerConfig = () => {
    if (!isConfigurable) {
      return <NoTriggerConfig />;
    }

    return workflowDetailStore.triggerNode?.data?.baseTriggerModel?.type === 'SCHEDULER_TRIGGER' ? (
      <SchedulerConfig />
    ) : (
      <DirectApiConfig />
    );
  };

  return (
    <Container isEditTable={isEditTable}>
      {/* <TriggerName>{t('Workflow_Create_20')}</TriggerName> */}
      {/* {renderTriggerConfig()} */}
      {/* {isConfigurable ? ( */}
      {/* <> */}
      <TriggerName>{t('Workflow_Create_20')}</TriggerName>
      {renderTriggerConfig()}
      {/* </> */}
      {/* ) : null} */}
    </Container>
  );
};

const Container = styled.div<{ isEditTable: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  background: inherit;
  padding: 36px 32px;
  ${({ isEditTable }) => isEditTable && 'padding: 0px;'}
`;

const TriggerName = styled.strong`
  display: flex;
  flex-direction: row;
  width: 100%;
  ${fonts.Headline7};
  color: ${({ theme: { colors } }) => colors['text-gray-main']};
  margin-bottom: 16px;
`;
